<!--
 * @Author: DESKTOP-FKE5GMS\17601 1760178806@qq.com
 * @Date: 2023-11-23 16:35:15
 * @LastEditors: DESKTOP-FKE5GMS\17601 1760178806@qq.com
 * @LastEditTime: 2023-11-23 17:41:50
 * @FilePath: \合联\oms\src\view\analysis\exportManager\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/analysis/exportManager";
export default {
  name: "exportManager",
  components: {
    cTable
  },
  data() {
    return {
      methods: {
        ...apis
      },
      config: {},
      footer: {},
      modals: {},
      header: {
        searchs: [
          {
            key: "startTime",
            placeholder() {
              return this.$tz("请选择,开始,日期");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "150px"
              }
            }
          },
          {
            key: "endTime",
            placeholder() {
              return this.$tz("请选择,结束,日期");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "150px"
              }
            }
          },
          {
            key: "type",
            placeholder() {
              return this.$tz("导出,类型");
            },
            component: "Select",
            options: [],
            optionsFn: "exportType",
            optionsKey: ""
          },
          {
            key: "status",
            placeholder() {
              return this.$tz("导出,状态");
            },
            component: "Select",
            options: [],
            optionsFn: "exportStatus",
            optionsKey: ""
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [],
          methods: {}
        }
      },
      fields: [
        {
          name: () => this.$tz("任务,ID"),
          key: "id",
          minWidth: 110
        },
        {
          name: () => this.$tz("导出,标题"),
          key: "title",
          minWidth: 130
        },
        {
          name: () => this.$tz("导出,类型"),
          key: "type_name",
          minWidth: 130
        },
        {
          name: () => this.$tz("导出,状态"),
          key: "status_name",
          minWidth: 130
        },
        {
          name: () => this.$tz("错误,信息"),
          key: "msg",
          minWidth: 130
        },
        {
          name: () => this.$tz("耗时"),
          key: "take_up_time",
          minWidth: 130
        },
        {
          name: () => this.$tz("创建时间"),
          key: "create_time",
          minWidth: 130
        },
        {
          name: () => this.$tz("文件,地址"),
          key: "src",
          minWidth: 130,
          component: "Button",
          bind: {
            type: "primary",
            size: "small"
          },
          disabled: ({ row }) => !row.src,
          methods: {
            render() {
              return "下载";
            },
            click({ row }) {
              this.$page.openUrl(row.src);
            }
          }
        },
        {
          name: () => this.$tz("备注"),
          key: "remarks",
          minWidth: 130
        }
      ]
    };
  }
};
</script>

<style scoped></style>
